









































/* General */
import Vue from 'vue'
import ProjectSettingsLayout from '@/layouts/project-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'
import GithubIntegrationAccordion from '@/components/entity/integrations/github-integration-accordion.vue'
import GlipIntegrationAccordion from '@/components/entity/integrations/glip-integration-accordion.vue'
import HarvestIntegrationAccordion from '@/components/entity/integrations/harvest-integration-accordion.vue'
import SlackIntegrationAccordion from '@/components/entity/integrations/slack-integration-accordion.vue'

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import { IProjectsOutputIntegrations } from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'

export default Vue.extend({
  name: 'ProjectSettingsIntegrations',

  metaInfo(): any {
    return {
      title: `Integrations - ${this.formData.name}`,
    }
  },

  components: {
    ProjectSettingsLayout,
    EntitySettingsLoading,
    GithubIntegrationAccordion,
    GlipIntegrationAccordion,
    HarvestIntegrationAccordion,
    SlackIntegrationAccordion,
  },

  data() {
    return {
      EEntities,
      isLoading: true,
      activeItem: this.$route.query.activeItem,
      formData: {
        name: '',
      } as IProjectsOutputIntegrations,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },

  async created() {
    this.isLoading = true
    await this.getIntegrationsInfo()
    this.isLoading = false
  },

  methods: {
    async getIntegrationsInfo() {
      try {
        this.formData = await InternalProjectsAPI.get_Integrations(this.id)
      } catch (error) {
        this.$error.emit(error)
      }
    },

    collapseChangeHandler(activeItem: string): void {
      this.$router.replace({
        ...this.$router,
        query: { activeItem },
      })
    },
  },
})
